define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		postProcessSuccess: function() {
			// summary: refresh table view after updating SKUs
			var	view;
			if (this.widget.viewParent){
				view = this.widget.viewParent.getChildView("PartMaterials");
				if (view) {
					view.refreshWidget(true);
				}
			}
		}
	});
});